/**
 * Services
 */
export * from './services/cell-render-factory';
export * from './services/service-locator';
export * from './services/row-model-generator';
export * from './services/group-model-generator';
export * from './services/freeze-row-model-generator';
export * from './services/value-formatter';
export * from './services/virtual-row-model-generator';
export * from './services/intersection-observer';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-grids/src/grid/services.js
// module id = 1163
// module chunks = 0